import React, { useState } from "react";
import styled from "styled-components";
import { useRecoilState } from "recoil";
import { Flex } from "rebass/styled-components";
import Lottie from "lottie-react";

import { Subheader } from "../../Text";
import { remixModal } from "../../../../globalStorage/remix";
import { useRemixButton } from "../../../Hooks/useRemixButton";
import { FloatingContainer } from "../../Wrappers";
import DefaultCardsRemixClip from "./Components/DefaultCardsButton";
import { ReactComponent as Customize } from "../../../Assets/Studio/Customize.svg";
import Cards from "../../../Assets/Studio/remixModal.png";

import RemixProcessing from "./RemixProcessing";
import { RemixModalViewModel } from "./ViewModel";
import loading from "../../../../animations/loading.json";
import {
  RemixModalImage,
  StyledButton,
  StyledContainer,
  StyledFootnote,
  StyledTitle3,
} from "./styledComponents";
import { SignatureSelectorState } from "../../../State/loadoutSelector";

const getMomentGameName = (gameKey: string): string => {
  const MOMENT_GAME_MAP: Record<string, string> = {
    CS2: "CS2",
    CS_GO: "CS:GO",
    DOTA2: "Dota 2",
    FORTNITE: "Fortnite",
    LOL: "LoL",
    OW2: "OW2",
  };

  return MOMENT_GAME_MAP[gameKey] || gameKey;
};

export function RemixModal({
  momentId,
  closeModal,
}: {
  momentId: string;
  closeModal: () => void;
}) {
  const [remixQueued, setRemixQueued] = useState(false);
  const remixButton = useRemixButton();
  const [, setModalOpen] = useRecoilState(remixModal);

  const {
    myCreatorCards,
    loading: myCreatorCardsLoading,
    momentCreateClip,
    moment,
  } = RemixModalViewModel(momentId);
  const [signatureState] = useRecoilState(SignatureSelectorState);

  if (remixQueued)
    return (
      <RemixProcessing
        closeModal={() => {
          closeModal();
        }}
      />
    );

  if (!myCreatorCards || myCreatorCardsLoading || !moment)
    return (
      <Lottie
        animationData={loading}
        style={{ height: 28, width: 28 }}
        loop={true}
      />
    );
  const cardIds = myCreatorCards.map((card) => card._id);

  return (
    <>
      <StyledFloatingContainerTwo
        flexDirection="column"
        alignItems="stretch"
        justifyContent="center"
        maxWidth="525px"
      >
        <>
          <RemixModalImage src={Cards} />
          <Flex
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
          >
            <Flex mt={5} flexDirection="column">
              <StyledTitle3 mb={6} textAlign="center">
                Remix {moment?.title}
              </StyledTitle3>
            </Flex>
          </Flex>
          <Flex flexDirection="column">
            <Flex
              flexDirection={["column", "column", "row"]}
              justifyContent="center"
              alignItems="center"
              width="100%"
              style={{ gap: 50 }}
            >
              <DefaultCardsRemixClip
                disabled={
                  !myCreatorCards.length && !signatureState?.mySignature?.active
                }
                checked={false}
                onClick={async () => {
                  await momentCreateClip({
                    variables: {
                      momentCreateClipInput: {
                        ids: [moment.id],
                        matchId: moment.match?.id,
                        effectsOverrides: {
                          applySignatureCards: true,
                          creatorCards: cardIds,
                        },
                      },
                    },
                  });
                  setRemixQueued(true);
                  setModalOpen(true);
                }}
              ></DefaultCardsRemixClip>
              <StyledContainer
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
              >
                <StyledButton
                  justifyContent="center"
                  textAlign="center"
                  classification="actionIcons"
                  alignItems="center"
                  onClick={() => {
                    window.rudderanalytics.track("remix customize click", {});
                    setModalOpen(true);
                    remixButton(moment?.id, getMomentGameName(moment?.game));
                  }}
                >
                  <Flex
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                  >
                    <Customize />
                  </Flex>
                  <Subheader mt={3}>Customize Clip</Subheader>
                  <StyledFootnote>Choose from over 300+ effects</StyledFootnote>
                </StyledButton>
              </StyledContainer>
            </Flex>
          </Flex>
        </>
      </StyledFloatingContainerTwo>
    </>
  );
}
const StyledFloatingContainerTwo = styled(FloatingContainer)`
  display: flex;
  flex-direction: column;
  max-width: 525px;
  position: relative;
`;
